/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2023-10-08 10:14:00
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-05-14 14:54:31
 * @FilePath: \zeelool_pc\common\AWS-S3-upload.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getS3Url } from '@/api/public';
import axios from 'axios';
import BMF from 'browser-md5-file';

/**
 * 文件上传到AWS S3服务（Promise版本）
 * @param {number} status 上传场景ID (2:处方图, 4:商品评论, 5:Email附件)
 * @param {object} file 要上传的文件对象
 * @param {function} onProgress 上传进度回调函数 (可选)
 * @returns {Promise<string>} 返回上传成功后的文件路径
 */
export const awsUpload = (status, file, onProgress) => {
  return new Promise((resolve, reject) => {
    let path = '';

    // 根据不同的业务场景设置存储路径
    const statusMap = {
      2: () => {
        // 用户侧 PC 处方图
        path = 'customer/pc/prescription/';
      },
      4: () => {
        // 用户侧 PC 商品评论
        path = 'customer/pc/review/';
      },
      5: () => {
        // 用户侧 PC Email US 附件
        path = 'customer/pc/emailus/';
      },
    };

    if (!status) {
      return reject(new Error('请传入要上传的场景值'));
    }

    // 设置存储路径
    statusMap[status]();

    // 计算文件MD5值
    const bmf = new BMF();
    bmf.md5(file, (err, md5) => {
      if (err) {
        return reject(err);
      }

      // 获取文件扩展名并构建完整路径
      const fileType = file.name.toLowerCase().split('.').splice(-1);
      path = `${path}${md5}.${fileType}`;

      // 根据文件类型设置Content-Type
      let contentType = '';
      switch (fileType[0]) {
        case 'jpg':
        case 'jpeg':
          contentType = 'image/jpeg';
          break;
        case 'png':
          contentType = 'image/png';
          break;
        case 'gif':
          contentType = 'image/gif';
          break;
        case 'docx':
          contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        case 'doc':
          contentType = 'application/msword';
          break;
        case 'xls':
          contentType = 'application/vnd.ms-excel';
          break;
        case 'xlsx':
          contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          break;
        case 'pdf':
          contentType = 'application/pdf';
          break;
        default:
          contentType = 'application/x-www-form-urlencoded';
      }

      try {
        // 获取S3上传URL
        getS3Url(path)
          .then((response) => {
            const { url } = response.data;

            // 执行上传请求
            return axios({
              url,
              method: 'put',
              data: file,
              timeout: 30000,
              headers: {
                'Content-Type': contentType,
              },
              // 上传进度回调
              onUploadProgress: (progressEvent) => {
                if (typeof onProgress === 'function') {
                  const percent = (progressEvent.loaded / progressEvent.total) * 100;
                  onProgress(percent, { md5 });
                }
              },
            });
          })
          .then((res) => {
            if (res.status === 200) {
              resolve(`/${path}`);
            } else {
              reject(new Error(`上传失败，状态码: ${res.status}`));
            }
          })
          .catch((error) => {
            if (error.code === 'ECONNABORTED') {
              // console.log('请求超时');
            }
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  });
};

/**
 * 文件上传到AWS S3服务（兼容旧版回调方式）
 * @param {number} status 上传场景ID (2:处方图, 4:商品评论, 5:Email附件)
 * @param {object} file 要上传的文件对象
 * @param {object} $api API对象(未使用)
 * @param {object} callbackObj 回调对象，包含success、fail、process和finally回调函数
 * @deprecated 请使用返回Promise的awsUpload方法
 */
export const awsUploadWithCallback = (status, file, $api, callbackObj) => {
  awsUpload(status, file, callbackObj?.process)
    .then((path) => {
      callbackObj.success && callbackObj.success(path);
    })
    .catch((error) => {
      callbackObj.fail && callbackObj.fail(error);
    })
    .finally(() => {
      // 由于MD5信息在Promise版本中无法获取，这里不再传递md5
      callbackObj.finally && callbackObj.finally();
    });
};
